// Google Analytics Tracking ID
export const TRACKING_ID = "G-VP2QFFG6R8";
